import { render, staticRenderFns } from "./club-dashboard.vue?vue&type=template&id=453e7688"
import script from "./club-dashboard.vue?vue&type=script&lang=js"
export * from "./club-dashboard.vue?vue&type=script&lang=js"
import style0 from "./club-dashboard.vue?vue&type=style&index=0&id=453e7688&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453e7688')) {
      api.createRecord('453e7688', component.options)
    } else {
      api.reload('453e7688', component.options)
    }
    module.hot.accept("./club-dashboard.vue?vue&type=template&id=453e7688", function () {
      api.rerender('453e7688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club-admins/dashboard/club-dashboard.vue"
export default component.exports